module.exports = __webpack_public_path__ + "static/media/DMstep4.d96da1c5.png";